import React, { useEffect } from "react";
import "./privacyTerms.scss";
import { Helmet } from "react-helmet";
import MetaTagContents from "../../MetaTagContents";

function Terms() {
    useEffect(() => {
        window.addEventListener("scroll", () => {
            let elmnt = document.getElementsByClassName("heading-alignment");
            if (elmnt && elmnt[0] && elmnt[0].offsetHeight) {
                let updatedElem =
                    window.document.getElementsByClassName("navbar-light");
                if (updatedElem && updatedElem[0]) {
                    if (window.scrollY > elmnt[0].offsetHeight) {
                        updatedElem[0].classList.add("full-opacity");
                    } else {
                        updatedElem[0].classList.remove("full-opacity");
                    }
                }
            }
        });
    }, []);
    const { name, content } = MetaTagContents.TERMS;
    return (
        <body className="terms-and-privacy" style={{ marginTop: "50px" }}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{MetaTagContents.TERMS.title}</title>
                <link rel="canonical" href="https://all3d.ai/terms" />
                <meta name={name} content={content} />
            </Helmet>
            <div className="heading-alignment">
                <h1 className="manrope f-38 w-600 lh-46 black-2b">Terms of Service</h1>
                <p className="manrope f-24 w-500 lh-32 black-2b">Last updated on December 11, 2025</p>
            </div>

            <p className="manrope f-20 w-500 lh-28 grey-73">
                Welcome to ALL3D. These Terms of Service ("Terms") govern your access to and use of ALL3D’s websites, applications (including iOS/Android), APIs, tools, and services for 3D modeling, AI image generation, and immersive experiences (collectively, the "Services").
            </p>
            <p className="manrope f-20 w-500 lh-28 grey-73">
                By accessing or using the Services, you agree to these Terms. If you do not agree, do not use the Services.
            </p>
            <p className="manrope f-20 w-500 lh-28 grey-73">
                Your use of the Services is also governed by our <a href="/privacy"><b>Privacy Policy</b></a> which explains how we handle information. For clarity, <b>ALL3D does not retain personally identifiable information (PII)</b>; see the <a href="/privacy">Privacy Policy</a> for details.
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">1. Overview of the Services</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D provides tools to <b>create, scan, upload, configure, render, and distribute 3D models, 3D CGI, AI images,</b> textures, scenes, 360 spins, virtual tours, AR/VR experiences, <b>3D Configurators</b> and related assets. Users may choose to keep assets <b>PRIVATE</b> or mark them <b>PUBLIC</b> (including for sale or free with Creative Commons licensing) through the ALL3D store. Users may also share assets within organizations and with partners for embedding and/or download.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We serve customers globally.
            </p>


            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">2. Eligibility & Accounts</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ul>
                    <li>
                        You must be at least 13 years old to use the Services (additional parental/guardian consent may be required where applicable).
                    </li>
                    <li>
                        You are responsible for your account credentials and all activities under your account.

                    </li>
                    <li>
                        You must provide accurate information and keep it current. We may refuse, suspend, or reclaim usernames at our discretion.
                    </li>
                </ul>
            </p>

            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">3. Plans, Billing & Renewals</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ol>
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.1 Plan Types</div>
                        <div>
                            We offer <b>Free</b> and <b>Paid</b> tiers with different functionality. Plan details may change over time.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.2 Automatic Renewal & Billing</div>
                        <div>
                            Paid plans automatically renew for the then-current billing period unless canceled in accordance with Section 3.5. By subscribing, you authorize recurring charges to your payment method for the applicable fees and taxes.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.3 Pricing and Changes</div>
                        <div>
                            Prices, commissions, and fees may change; we will provide notice where required by law. If you do not agree to changes, you must cancel before the next renewal.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.4 Payment Processing</div>
                        <div>
                            Payments are handled by third-party processors that comply with industry standards (e.g., PCI-DSS). ALL3D does not store your full card details.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.5 Cancellations & Refunds</div>
                        <div>
                            You may cancel at any time unless you are on enterprise contracts, and your plan remains active through the end of the current billing period. Unless required by law, fees are non-refundable. ALL3D does not offer refunds.
                        </div>
                    </li>
                </ol>
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">4. Storefront, Licensing & Revenue Share</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ol>
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">4.1 Selling & Sharing Content</div>
                        <div>
                            Users may (i) keep assets PRIVATE; (ii) make assets available <b>for free</b> under a Creative Commons license; or (iii) make assets available <b>for purchase</b> in the ALL3D store. You are solely responsible for selecting any applicable license terms.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">4.2 Revenue Share</div>
                        <div>
                            For store sales, ALL3D currently takes a 9% commission per sale (excluding 3%–5% payment processing charges). These amounts may be updated; we will provide notice where required by law.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">4.3 Taxes</div>
                        <div>
                            You are responsible for all applicable taxes, duties, and fees associated with sales of your content, and you authorize ALL3D and/or its processors to withhold or collect such amounts where required.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.4 Payment Processing</div>
                        <div>
                            Payments are handled by third-party processors that comply with industry standards (e.g., PCI-DSS). ALL3D does not store your full card details.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">3.5 Cancellations & Refunds</div>
                        <div>
                            You may cancel at any time unless you are on enterprise contracts, and your plan remains active through the end of the current billing period. Unless required by law, fees are non-refundable. ALL3D does not offer refunds.
                        </div>
                    </li>
                </ol>
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">5. User Content & Licenses</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ol>
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.1 Definitions</div>
                        <div>
                            <b>"User Content"</b> includes 3D models (products and spaces), <b>AI images</b>, textures, product/lifestyle images, scenes, 360 spins, 3D tours, metadata, prompts, scans, and related materials you upload, create, or generate via the Services. <b>"ALL3D Content"</b> means content provided by ALL3D (excluding User Content).
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.2 Ownership</div>
                        <div>
                            You retain ownership of your User Content, subject to the licenses granted below and applicable third-party rights. ALL3D and its licensors own the Services and ALL3D Content.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.3 License to ALL3D (Service Operation & Promotion)</div>
                        <div>
                            You grant ALL3D a worldwide, non-exclusive, royalty-free, sublicensable, transferable license to host, reproduce, adapt, modify, translate, process, transmit, display, and distribute your User Content <b>to operate, maintain, secure, and promote the Services</b> (e.g., rendering, content delivery, moderation, and showcasing public assets).
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.4 AI Model Training License</div>
                        <div>
                            To improve generative quality and performance, <b>ALL3D uses open-source AI models which it trains on ALL3D data and/or integrates as modules.
                                <br />
                                By using the Services, you grantALL3D a worldwide, non-exclusive, royalty-free, sublicensable, transferable, perpetual license to use your User Content (including 3D models, 3D CGI and AI images) as training data and evaluation data for AI models</b>, provided that ALL3D does not use any personally identifiable information (PII) and applies technical and organizational safeguards consistent with the Privacy Policy.
                            <br />
                            If you prefer to <b>exclude specific assets</b> from future training, you may mark them "Do Not Train" (where available) or contact us.
                            <br />
                            Note: already-trained model parameters typically cannot be reversed to remove previously learned information.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.5 License to Other Users (Free / Paid)</div>
                        <ul>
                            <li>
                                <b>Free (Creative Commons)</b>: If you choose a CC license, other users may use your content under that license’s terms.
                            </li>
                            <li>
                                <b>Paid (Store Purchases)</b>: Upon purchase, customers obtain a non-exclusive, non-transferable license to use the purchased asset(s) to create derivative works (e.g., scenes, AI images, renders) on or off the ALL3D platform, subject to any restrictions shown at purchase.
                            </li>
                        </ul>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.6 Moral Rights; Attribution</div>
                        <div>
                            Where permitted by law, you waive (or agree not to assert) moral rights against ALL3D for permitted uses under these Terms. Where a license requires attribution, users must provide it as required.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">5.7 Responsibility for User Content</div>
                        <div>
                            You are solely responsible for your User Content and for obtaining all necessary rights and permissions. You represent and warrant that your User Content and use of the Services will not infringe or violate any third-party rights or laws.
                        </div>
                    </li>
                </ol>
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">6. Acceptable Use</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                You agree not to:
                <br />
                <br />
                <ul>
                    <li>
                        Violate laws or third-party rights (IP, privacy, publicity).
                    </li>
                    <li>
                        Upload malicious code, attempt to bypass security, or degrade Service performance.
                    </li>
                    <li>
                        Misuse the Services to create or improve competing models or services.
                    </li>
                    <li>
                        Upload unlawful, hateful, harassing, or pornographic material, or content inappropriate for those under 13.
                    </li>
                    <li>
                        Misrepresent your identity or affiliation.
                    </li>
                    <li>
                        Engage in automated scraping except via approved APIs.
                    </li>
                </ul>
                We may remove content, rate-limit, suspend, or terminate accounts that violate these Terms.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">7. Privacy; No PII Retention</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                ALL3D <b>does not retain PII</b> about users/customers. Limited technical/operational data may be processed as described in the <a href="/privacy"><b>Privacy Policy</b></a>. By using the Services, you consent to the practices described in the Privacy Policy.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">8. Intellectual Property; DMCA</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We respect IP rights and comply with the DMCA. If you believe content infringes your rights, submit a notice to our designated agent through the email address <b>support@all3d.ai</b>. We may remove content and terminate repeat infringers.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">9. Open-Source & Third-Party Services</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                The Services may include or interoperate with <b>open-source AI models</b> and other third-party components. Use of third-party services (e.g., payment processors, app stores, hosting, analytics) is subject to their terms. We do not control third-party services and are not responsible for their acts or omissions.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">10. Software License & Updates</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We grant you a limited, non-exclusive, non-transferable license to use our applications and tools as part of the Services. Reverse engineering or circumventing technical protections is prohibited. We may release updates automatically; these Terms apply to updates.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">11. Modifications to the Services</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We may change or discontinue features with notice where required. If you do not agree with changes, you may stop using the Services and/or cancel your plan.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">12. Termination</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ol>
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">12.1 By You</div>
                        <div>
                            You may stop using the Services at any time and cancel your plan per Section 3.5.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">12.2 By ALL3D</div>
                        <div>
                            We may suspend or terminate your account or access immediately for violations of these Terms, unlawful activity, non-payment, or risk to users or the platform.
                        </div>
                    </li>
                    <br />
                    <li>
                        <div className="manrope f-18 w-500 lh-28 black-085">12.3 Post-Termination</div>
                        <div>
                            Upon termination, your right to access the Services ends. We will delete your User Content (including 3D models and AI images) from active systems within 30 days. To request deletion, you may send an email to <b>support@all3d.ai</b>. Model parameters already trained on data cannot typically be reversed.
                        </div>
                    </li>
                </ol>
            </p>
            <br />

            <h2 className="manrope f-20 w-600 lh-28 black-085">13. Disclaimers</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                THE SERVICES AND ALL CONTENT ARE PROVIDED “AS IS” AND “AS AVAILABLE.” TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND NON-INTERFERENCE WITH ENJOYMENT. We do not guarantee uninterrupted or error-free operation or that content will meet your requirements.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">14. Limitation of Liability</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, ALL3D AND ITS AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, LICENSORS, AND PARTNERS WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL. OUR AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO THE SERVICES WILL NOT EXCEED US $100.
            </p>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Some jurisdictions do not allow certain limitations; in those cases, the limitations apply to the fullest extent permitted.
            </p>

            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">15. Indemnification</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                You will defend, indemnify, and hold harmless ALL3D and its affiliates, officers, directors, employees, and agents from and against claims, liabilities, damages, losses, and expenses (including reasonable attorneys’ fees) arising out of or related to your User Content, your use of the Services, or your violation of these Terms or applicable law.
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">16. Dispute Resolution; Arbitration; Class Waiver</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                <ul>
                    <li>
                        <b>Governing Law.</b> These Terms are governed by the laws of the State of California (conflict-of-laws rules excluded).
                    </li>
                    <li>
                        <b>Arbitration.</b> Any dispute will be resolved by <b>final and binding arbitration</b> in San Francisco County, California, administered by JAMS under its Streamlined Arbitration Rules if the parties cannot agree on procedures within 15 days. Judgment on the award may be entered in any court of competent jurisdiction.
                    </li>
                    <li>
                        <b>Injunctive Relief.</b> Either party may seek provisional relief in court to protect rights pending arbitration.
                    </li>
                    <li>
                        <b>Class Action and Jury Trial Waiver.</b> You and ALL3D agree to individual-only proceedings; no class actions or representative claims. Jury trial is waived.
                    </li>
                    <li>
                        <b>Time To Bring Action.</b> Any claim must be filed within <b>one (1) year</b> after it accrues.
                    </li>
                </ul>
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">17. Export & U.S. Government Rights</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                You must comply with applicable export control laws. The software is “commercial computer software” and related documentation as defined in 48 C.F.R. §2.101 and is licensed to U.S. Government users only with the rights granted to all other end users under these Terms.
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">18. Changes to These Terms</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                We may update these Terms from time to time. Where required, we will provide advance notice (e.g., via the Service or email). Your continued use after the effective date constitutes acceptance of the updated Terms. If you do not agree, you must stop using the Services and cancel your plan.
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">19. Miscellaneous</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                These Terms (plus any referenced documents) are the entire agreement between you and ALL3D. If any provision is unenforceable, it will be modified to reflect the parties' intent, and the remainder will stay in effect. You may not assign these Terms without our consent; we may assign at any time. No waiver is implied by delay or omission. “Including” means “including without limitation.” Notices may be provided electronically.
            </p>
            <br />
            <h2 className="manrope f-20 w-600 lh-28 black-085">20. Contact</h2>
            <p className="manrope f-18 w-500 lh-28 grey-73">
                Questions? Contact us at:
                <b>support@all3d.ai</b>
            </p>
        </body>);
}

export default Terms;